import React from 'react'
import PropTypes from 'prop-types'
import {polyglot} from '../../../../index'
import { ReactModal } from '../../../common/ReactModal/ReactModal'
import FluorRegistrationForm from '../FluorRegistrationForm/FluorRegistrationForm'
import { Panel } from '../../../common/Panel/Panel'

class ResidencyFluorTable extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  toggleModal () {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  handleSubmit (mark) {
    if (mark.location !== null && mark.townHall !== null && mark.value !== null) {
      this.props.handleChange(mark)
      this.toggleModal()
    } else {
      return false
    }
  }

  render () {
    return (
      <div>
        <Panel heading={polyglot.t('fluorOfResidency.title')} footer={
          <button type='button' onClick={this.toggleModal} className='btn btn-default btn-lg btn-block'>{polyglot.t('commonFields.add')}</button>}>
          {!this.props.elements ? <h3>{polyglot.t('commonFields.noInformation')}</h3> : <div className='table-responsive'>
            <table className='table table-bordered'>
              <thead>
                <tr>
                  <th>{polyglot.t('fluorOfResidency.location')}</th>
                  <th>{polyglot.t('fluorOfResidency.townHall')}</th>
                  <th>{polyglot.t('fluorOfResidency.value')}</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(this.props.elements).map(function (key, index) {
                  return (
                    <tr key={index}>
                      <td>{this.props.elements[key].location}</td>
                      <td>{this.props.elements[key].townHall}</td>
                      <td>{this.props.elements[key].value}</td>
                    </tr>
                  )
                }.bind(this))}

              </tbody>
            </table>
          </div>
          }
        </Panel>
        <ReactModal name={polyglot.t('fluorOfResidency.title')} toggleModal={this.toggleModal} modalIsOpen={this.state.modalIsOpen} >
          <FluorRegistrationForm config={this.props.config} currentPatientData={this.props.currentPatient} onSubmit={this.handleSubmit} />
        </ReactModal>
      </div>

    )
  }
}

ResidencyFluorTable.propTypes = {
  config: PropTypes.object.isRequired,
  currentPatient: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  elements: PropTypes.object
}

export default ResidencyFluorTable



// WEBPACK FOOTER //
// ./src/components/general/FluorInfo/ResidencyFluorTable/ResidencyFluorTable.js